import React, { useState, useEffect } from 'react';
import { Search, X, MessageSquare, Folder, Zap } from 'lucide-react';
import { getMensagensPredefinidas, getCategoriasMensagens } from '../services/api';
import './MensagensRapidas.css';

const MensagensRapidas = ({ onSelectMessage, chatInfo = {} }) => {
  const [mensagens, setMensagens] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [categoriaSelecionada, setCategoriaSelecionada] = useState('todas');
  const [busca, setBusca] = useState('');
  const [loading, setLoading] = useState(true);
  const [showPanel, setShowPanel] = useState(false);

  useEffect(() => {
    if (showPanel) {
      carregarMensagens();
      carregarCategorias();
    }
  }, [showPanel, categoriaSelecionada, busca]);

  const carregarMensagens = async () => {
    try {
      setLoading(true);
      const response = await getMensagensPredefinidas(
        true, // apenas ativas
        categoriaSelecionada === 'todas' ? null : categoriaSelecionada,
        busca || null
      );
      setMensagens(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar mensagens:', error);
      setMensagens([]);
    } finally {
      setLoading(false);
    }
  };

  const carregarCategorias = async () => {
    try {
      const response = await getCategoriasMensagens();
      setCategorias(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar categorias:', error);
    }
  };

  const substituirVariaveis = (conteudo) => {
    if (!chatInfo) return conteudo;
    
    const variaveis = {
      nome_cliente: chatInfo.customer_name || chatInfo.name || 'Cliente',
      protocolo: chatInfo.protocolo || chatInfo.id || '',
      telefone: chatInfo.phone || '',
      agente: chatInfo.agente || 'Agente',
      data: new Date().toLocaleDateString('pt-BR'),
      hora: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    };

    let texto = conteudo;
    for (const [key, value] of Object.entries(variaveis)) {
      texto = texto.replace(new RegExp(`\\{${key}\\}`, 'g'), value);
    }

    return texto;
  };

  const handleSelectMessage = (mensagem) => {
    const conteudoSubstituido = substituirVariaveis(mensagem.conteudo);
    if (onSelectMessage) {
      onSelectMessage(conteudoSubstituido);
    }
    setShowPanel(false);
  };

  const mensagensFiltradas = mensagens.filter(msg => {
    if (categoriaSelecionada !== 'todas' && msg.categoria !== categoriaSelecionada) {
      return false;
    }
    if (busca) {
      const termo = busca.toLowerCase();
      return (
        msg.titulo.toLowerCase().includes(termo) ||
        msg.conteudo.toLowerCase().includes(termo) ||
        (msg.atalho && msg.atalho.toLowerCase().includes(termo))
      );
    }
    return true;
  });

  return (
    <div className="mensagens-rapidas-container">
      <button
        className="mensagens-rapidas-toggle"
        onClick={() => setShowPanel(!showPanel)}
        title="Mensagens Rápidas"
      >
        <Zap size={18} />
      </button>

      {showPanel && (
        <div className="mensagens-rapidas-panel">
          <div className="mensagens-rapidas-header">
            <h3>Mensagens Rápidas</h3>
            <button
              className="mensagens-rapidas-close"
              onClick={() => setShowPanel(false)}
            >
              <X size={18} />
            </button>
          </div>

          <div className="mensagens-rapidas-search">
            <Search size={16} />
            <input
              type="text"
              placeholder="Buscar mensagens..."
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
            />
          </div>

          <div className="mensagens-rapidas-filters">
            <div className="mensagens-rapidas-categorias">
              <Folder size={14} />
              <select
                value={categoriaSelecionada}
                onChange={(e) => setCategoriaSelecionada(e.target.value)}
              >
                <option value="todas">Todas as categorias</option>
                {categorias.map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="mensagens-rapidas-list">
            {loading ? (
              <div className="mensagens-rapidas-loading">Carregando...</div>
            ) : mensagensFiltradas.length === 0 ? (
              <div className="mensagens-rapidas-empty">
                Nenhuma mensagem encontrada
              </div>
            ) : (
              mensagensFiltradas.map((mensagem) => (
                <div
                  key={mensagem.id}
                  className="mensagens-rapidas-item"
                  onClick={() => handleSelectMessage(mensagem)}
                >
                  <div className="mensagens-rapidas-item-header">
                    <MessageSquare size={14} />
                    <span className="mensagens-rapidas-item-titulo">
                      {mensagem.titulo}
                    </span>
                    {mensagem.atalho && (
                      <span className="mensagens-rapidas-item-atalho">
                        {mensagem.atalho}
                      </span>
                    )}
                  </div>
                  {mensagem.categoria && (
                    <div className="mensagens-rapidas-item-categoria">
                      {mensagem.categoria}
                    </div>
                  )}
                  <div className="mensagens-rapidas-item-preview">
                    {substituirVariaveis(mensagem.conteudo).substring(0, 100)}
                    {mensagem.conteudo.length > 100 && '...'}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MensagensRapidas;

